import $ from "jquery"

function getPublicPaths(_extension) {
	return window?.bbConfig?.publicPaths[_extension] ?? '';
}

const Config = {
	debug: false,
	version: version,
	env: env,
	proxy: "",
	publicPath: "",
	documentRoot: "/",
	module: {
		external: [
			{
				selector: ".bb-iframe-resizer",
				css: [],
				js: [
					{
						url: getPublicPaths('bbIframe') + 'Scripts/iframeResizer.min.js',
						crossDomain: false,
						loadedCallback: () => {
							window.iFrameResize({ log: false, checkOrigin: false })
						},
					},
				],
			},
		],
	},
	map: {
		key: "AIzaSyC9I7lu5NUrc9H1bwdW9EpgNVd5qT6h3rA",
	},
	jobSearch: {
		defaultDistance: 25, // 25km
	},
	// faq: {
	// 	searchMinChar: 3,
	// 	highlightClass: "search-hit",
	// }
}

export default $.extend(true, Config, window.bbConfig)
